<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-click-outside="closeModal">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>

          <div class="modal-body text-center">
            <form id="item_form" @submit.prevent="validate()">
              <div class="md-layout">
                <div class="md-layout-item md-size-20">
                  <label class="md-form-label">Cliente</label>
                </div>
                <div class="md-layout-item md-size-75">
                  <md-field :class="validationClass('client')">
                    <label for="updatedItem.highwayCustomerId">Cliente</label>
                    <md-select
                      data-vv-name="client"
                      v-validate="modelValidations.client"
                      v-model="updatedItem.highwayCustomerId"
                      name="updatedItem.highwayCustomerId"
                      id="updatedItem.highwayCustomerId"
                    >
                      <md-option
                        :value="c.id"
                        v-for="c in mClients"
                        :key="c.id"
                        required
                      >{{ c.name }}</md-option>
                    </md-select>
                    <error-indicator :valid="validField('client')"></error-indicator>
                  </md-field>
                </div>
              </div>

              <div class="md-layout">
                <div class="md-layout-item md-size-20">
                  <label class="md-form-label">Carretera</label>
                </div>
                <div class="md-layout-item md-size-75">
                  <md-field :class="validationClass('highway')">
                    <label for="updatedItem.highwayId">Carretera</label>
                    <md-select
                      data-vv-name="highway"
                      v-validate="modelValidations.highway"
                      v-model="updatedItem.highwayId"
                      name="updatedItem.highwayId"
                      id="updatedItem.highwayId"
                    >
                      <md-option
                        :value="c.id"
                        v-for="c in mHighways"
                        :key="c.id"
                        required
                      >{{ c.name }}</md-option>
                    </md-select>
                    <error-indicator :valid="validField('highway')"></error-indicator>
                  </md-field>
                </div>
              </div>

              <!-- {{mTollbothAttendants}} -->

              <div class="md-layout">
                <div class="md-layout-item md-size-20">
                  <label class="md-form-label">Tramo Carretero</label>
                </div>
                <div class="md-layout-item md-size-75">
                  <md-field>
                    <label for="updatedItem.highwaySectionId">Seleccione Tramo</label>
                    <md-select
                      data-vv-name="highwaySection"
                      v-validate="modelValidations.highwaySection"
                      v-model="updatedItem.highwaySectionId"
                      name="updatedItem.highwaySectionId"
                      id="updatedItem.highwaySectionId"
                    >
                      <md-option
                        :value="d.id"
                        v-for="d in mHighwaySections"
                        :key="d.id"
                      >{{ d.name }}</md-option>
                    </md-select>
                    <error-indicator :valid="validField('highwaySection')"></error-indicator>
                  </md-field>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-size-20">
                  <label class="md-form-label">Coordinador electromecánico</label>
                </div>
                <div class="md-layout-item md-size-75">
                  <md-field :class="validationClass('tollboothAttendant')">
                    <label for="updatedItem.tollboothAttendantId">Encargado</label>
                    <md-select
                      data-vv-name="tollboothAttendant"
                      v-validate="modelValidations.tollboothAttendant"
                      v-model="updatedItem.tollboothAttendantId"
                      name="updatedItem.tollboothAttendantId"
                      id="updatedItem.tollboothAttendantId"
                    >
                      <md-option
                        :value="m.id"
                        v-for="m in mTollbothAttendants"
                        :key="m.id"
                      >{{ m.name }}</md-option>
                    </md-select>
                    <error-indicator :valid="validField('tollboothAttendant')"></error-indicator>
                  </md-field>
                </div>
              </div>

              <div class="md-layout">
                <label class="md-layout-item md-size-25 md-form-label">Nombre de Caseta</label>
                <div class="md-layout-item">
                  <md-field :class="validationClass('tollbooth')">
                    <md-input
                      data-vv-name="tollbooth"
                      v-validate="modelValidations.tollbooth"
                      v-model="updatedItem.name"
                      type="text"
                      name="updatedItem.name"
                    ></md-input>
                    <span class="md-helper-text">Ingrese Nombre de Caseta</span>
                    <error-indicator :valid="validField('tollbooth')"></error-indicator>
                  </md-field>
                </div>
              </div>

              <div class="md-layout">
                <div class="md-layout-item md-size-20">
                  <label class="md-form-label">Estado</label>
                </div>
                <div class="md-layout-item md-size-75">
                  <md-field :class="validationClass('state')">
                    <label for="updatedItem.state">Estados</label>
                    <md-select
                      data-vv-name="state"
                      v-validate="modelValidations.state"
                      v-model="updatedItem.stateId"
                      name="updatedItem.stateId"
                      id="updatedItem.stateId"
                    >
                      <md-option :value="s.id" v-for="s in mStates" :key="s.id">{{ s.name }}</md-option>
                    </md-select>
                    <error-indicator :valid="validField('state')"></error-indicator>
                  </md-field>
                </div>
              </div>

              <div class="md-layout">
                <div class="md-layout-item md-size-20">
                  <label class="md-form-label">Municipio</label>
                </div>
                <div class="md-layout-item md-size-75">
                  <md-field>
                    <label for="updatedItem.municipalityId">Municipio</label>
                    <md-select
                      v-model="updatedItem.municipalityId"
                      name="updatedItem.municipalityId"
                      id="updatedItem.municipalityId"
                    >
                      <md-option :value="m.id" v-for="m in mMunicipalitys" :key="m.id">{{ m.name }}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <md-button class="md-info md-round" type="submit" form="item_form">listo</md-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ErrorIndicator from "@/components/Validation/ErrorIndicator";
import { watchTouchedProperties } from "@/utils";
import dataService from "../../../services/catalog";

const modelValidations = {
  tollbooth: {
    required: true,
  },
  highway: {
    required: true,
  },
  highwaySection: {
    required: true,
  },
  municipality: {
    required: true,
  },
  state: {
    required: true,
  },
  tollboothAttendant: {
    required: true,
  },
};

export default {
  components: {
    ErrorIndicator,
  },

  props: {
    editedItem: Object,
    isRegister: Boolean,
  },

  data() {
    return {
      updatedItem: {},
      modelValidations,

      //Show metadatas
      mClients: [],
      mHighways: [],
      mHighwaySections: [],
      mTollbothAttendants: [],
      mStates: [],
      mMunicipalitys: [],
    };
  },

  methods: {
    closeModal: function () {
      this.$emit("close");
    },

    validate() {
      const sendObject = {
        original: this.editedItem,
        updated: this.updatedItem,
      };

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", sendObject);
        } else {
          this.$notify({
            message: "Llene Todos los campos Marcados",
            icon: "close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        }
      });
    },

    // Miscelanius methods
    consultMetas(ruta, asign, arg1, arg2) {
      // Make query for metaDatas
      let configuret;

      if (arg2) {
        configuret = {
          id: arg1,
          extraId: arg2,
          noStore: true,
          collection: true,
        };
      } else {
        configuret = { id: arg1, noStore: true };
      }
      dataService.fetch(ruta, configuret).then((res) => {
        this[asign] = res;
      });
    },

    consultMunicipality(id) {
      dataService
        .fetch("common/states", { id: id, noStore: true })
        .then((res) => {
          this.mMunicipalitys = res.Municipality;
        });
    },
  },

  mounted() {
    this.updatedItem = { ...this.editedItem };
    this.consultMetas("customer", "mClients");
    this.consultMetas("common/states", "mStates");
  },

  watch: {
    ...watchTouchedProperties("updatedItem", Object.keys(modelValidations)),

    "updatedItem.highwayCustomerId": function () {
      this.consultMetas(
        "highway/gethighway",
        "mHighways",
        this.updatedItem.highwayCustomerId
      );
      this.consultMetas(
        "customer/customerstaff",
        "mTollbothAttendants",
        this.updatedItem.highwayCustomerId,
        "coordinador-electromecanico"
      );
    },

    "updatedItem.stateId": function () {
      this.consultMunicipality(this.updatedItem.stateId);
    },

    "updatedItem.highwayId": function () {
      this.consultMetas(
        "highway/highwaysection/getsection",
        "mHighwaySections",
        this.updatedItem.highwayId
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/HighwayTollbooth/editModal.vue